/* BOLODOO real-life media v2 */
(() => {
  if (customElements.get('real-life-media')) return;
  class RealLifeMedia extends HTMLElement {
    connectedCallback() {
      if (this.closest('floated-form, .product__sticky, [data-sticky-cart]')) { this.remove(); return; }
      if (this.initialized) { this.listenForColorChanges(); return; }
      this.initialized = true;
      this.rail = this.querySelector('.real-life-media__rail');
      this.dialog = this.querySelector('dialog');
      if (!this.rail || !this.dialog) return;
      this.items = [...this.rail.children];
      if (!this.items.length) { this.remove(); return; }
      this.muteButton = this.querySelector('.real-life-media__mute');
      this.closeButton = this.querySelector('.real-life-media__close');
      this.previous = this.querySelector('.real-life-media__previous');
      this.next = this.querySelector('.real-life-media__next');
      this.videoLinks = this.items.map(item => item.querySelector('.real-life-media__open')).filter(link => link?.dataset.kind === 'video');
      this.prioritizeColor(this.dataset.currentColor);
      this.listenForColorChanges();
      this.addEventListener('click', event => {
        const link = event.target.closest('.real-life-media__open');
        if (!link || !this.contains(link) || !this.dialog.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(link);
      });
      this.closeButton.addEventListener('click', () => this.dialog.close());
      this.muteButton.addEventListener('click', () => {
        const video = this.dialog.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        this.updateMuteButton();
      });
      this.previous.addEventListener('click', () => this.open(this.videoLinks[this.videoIndex - 1]));
      this.next.addEventListener('click', () => this.open(this.videoLinks[this.videoIndex + 1]));
      this.dialog.addEventListener('keydown', event => {
        if (event.target.tagName !== 'VIDEO' && this.dialog.classList.contains('is-video') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          this.open(this.videoLinks[this.videoIndex + (event.key === 'ArrowLeft' ? -1 : 1)]);
          return;
        }
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]):not([hidden]), video[controls], a[href], [tabindex="0"]')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.stop();
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      });
      this.updateVideoControls();
    }
    prioritizeColor(value) {
      const normalize = color => String(color || '').trim().toLowerCase();
      const color = normalize(value);
      this.dataset.currentColor = value || '';
      [...this.items].sort((a, b) => Number(color && normalize(b.dataset.color) === color) - Number(color && normalize(a.dataset.color) === color)).forEach(item => this.rail.append(item));
    }
    listenForColorChanges() {
      const position = Number(this.dataset.colorOptionPosition);
      if (!Number.isInteger(position) || position < 1) return;
      this.productInfo = this.closest('[id^="ProductInfo-"]');
      if (!this.productInfo) return;
      this.onColorChange ||= event => {
        const picker = event.target.closest('variant-radios, variant-selects');
        if (!picker || !this.productInfo.contains(picker)) return;
        const selected = picker.querySelector(`[data-option-position="${position}"] input[type="radio"]:checked, [data-option-position="${position}"] select`);
        if (selected) this.prioritizeColor(selected.value);
      };
      this.productInfo.addEventListener('change', this.onColorChange);
    }
    open(link) {
      if (!link) return;
      this.opener = link;
      const isVideo = link.dataset.kind === 'video';
      this.stop();
      const media = document.createElement(isVideo ? 'video' : 'img');
      media.src = link.href;
      if (isVideo) {
        media.controls = true;
        media.autoplay = true;
        media.muted = true;
        media.loop = true;
        media.playsInline = true;
        media.preload = 'metadata';
        if (link.dataset.preview) media.poster = link.dataset.preview;
        media.setAttribute('aria-label', link.dataset.caption || 'Real-life video');
      } else media.alt = link.dataset.caption || '';
      this.dialog.querySelector('.real-life-media__stage').replaceChildren(media);
      this.dialog.querySelector('.real-life-media__caption').textContent = link.dataset.caption || '';
      this.dialog.classList.toggle('is-video', isVideo);
      this.videoIndex = isVideo ? this.videoLinks.indexOf(link) : -1;
      this.updateVideoControls();
      this.updateMuteButton();
      if (!this.dialog.open) this.dialog.showModal();
      if (isVideo) this.playCurrent();
      this.closeButton.focus();
    }
    stop() {
      const video = this.dialog?.querySelector('video');
      if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
      this.dialog?.querySelector('.real-life-media__stage')?.replaceChildren();
      this.dialog?.classList.remove('is-video');
    }
    playCurrent() {
      const video = this.dialog?.querySelector('video');
      if (!video) return;
      const play = () => video.play().catch(() => {});
      if (video.readyState >= 1) play();
      else video.addEventListener('loadedmetadata', play, { once: true });
    }
    updateMuteButton() {
      const video = this.dialog?.querySelector('video');
      if (!video || !this.muteButton) return;
      this.muteButton.querySelector('.real-life-media__sound-icon')?.classList.toggle('is-muted', video.muted);
      this.muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }
    updateVideoControls() {
      const isVideo = this.videoIndex >= 0;
      this.muteButton.hidden = !isVideo;
      this.previous.hidden = !isVideo;
      this.next.hidden = !isVideo;
      if (!isVideo) return;
      this.previous.disabled = this.videoIndex === 0;
      this.next.disabled = this.videoIndex === this.videoLinks.length - 1;
    }
    disconnectedCallback() {
      this.stop();
      this.productInfo?.removeEventListener('change', this.onColorChange);
    }
  }
  customElements.define('real-life-media', RealLifeMedia);
})();
